import { render, staticRenderFns } from "./Titlebar.vue?vue&type=template&id=c33f1cb2&"
import script from "./Titlebar.vue?vue&type=script&lang=js&"
export * from "./Titlebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VToolbarTitle})
